<template>
    <div class="row mb-3">
        <div class="col-sm-12 col-md-12">
            <ul class="warranty-submenu">
                <li>
                    <router-link :to="{name: 'DistributorRegisteredProductsWarrantyRequest'}"> Warranty Requests </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'DistributorRegisteredProductsWarrantyActive'}"> Active Warranties </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'DistributorRegisteredProductsWarrantyClose'}"> Closed Warranties </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WarrantySubNav',
    components: {},
    data() {
        return {};
    }
};
</script>
